// extracted by mini-css-extract-plugin
export default {"card":"Card_card__evwV0","title":"Card_title__SkhwX","separator":"Card_separator__I8oDW","titleContainer":"Card_titleContainer__UXWmh"};